import { render, staticRenderFns } from "./GeneralSettingsLocaleDefault.vue?vue&type=template&id=5a9d397f&"
import script from "./GeneralSettingsLocaleDefault.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsLocaleDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports